﻿(function () {
    'use strict';
    var controllerId = 'appmntCtainerEntryEditController';
    
    angular
        .module('app.controllers')
        .controller(controllerId, appmntCtainerEntryEditController);

    appmntCtainerEntryEditController.$inject = ['$location', 'common', 'datacontext'];

    function appmntCtainerEntryEditController($location, common, datacontext) {

        init();

        function init() {
            common.activateController([getTest()])
            .then(function () {
                common.logger.debug('------------------------------  ' + controllerId);
            });
        }

        function getTest() {
            return datacontext.security.getTest().then(function (data) {
                return data;
            });
        }

    }

})();